module.exports = __webpack_public_path__ + "static/img/signday_top.1d9a0184.png";